import classnames from 'classnames/bind'
import React from 'react'
import { GlobalGridPreset } from '~/@types/grid-preset'

import SearchBar from '~/components/UI/SearchBar'

import { useStyle } from '~/providers/StyleProvider'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export type SearchInputProps = {
  className?: string
  inputClassName?: string
  hasAutocomplete?: boolean
  autocompleteValue?: string
  suggestedValue?: string
  isSearching: boolean
  isFetching: boolean
}

function SearchInput({
  className,
  inputClassName,
  isSearching,
  isFetching,
  hasAutocomplete,
  autocompleteValue,
  suggestedValue,
}: SearchInputProps) {
  const gridStyle = useStyle({ grid: GlobalGridPreset.BASE_GRID })

  return (
    <div className={cx(css.SearchInput, gridStyle, className)}>
      <div className={css.content}>
        <SearchBar
          className={css.searchBar}
          hasReset
          hasAutocomplete
          isSearching={isSearching}
          isFetching={isFetching}
          inputClassName={inputClassName}
          autocompleteValue={autocompleteValue}
          suggestedValue={suggestedValue}
        />
      </div>
    </div>
  )
}

SearchInput.defaultProps = {}

export default SearchInput
